<template>
  <div id="user-edit-tab-info">
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="vx-col w-full mb-base">
          <template>
            <vs-table
              stripe
              max-items="4"
              pagination
              search
              :data="sortedOvertimeData"
            >
              <template slot="thead">
                <vs-th @click.native="sort('overtimeTypeId')">Type</vs-th>
                <vs-th @click.native="sort('overtimeHours')">OT Hours</vs-th>
                <vs-th @click.native="sort('otRate')">OT Rate</vs-th>
                <!-- removed NSD Rate column as per payroll's request. Can be added back later if needed.
                <vs-th @click.native="sort('nsdRate')">NSD Rate?</vs-th> -->
                <vs-th @click.native="sort('hourlyRate')">Hourly Rate</vs-th>
                <vs-th>Action</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].overtimeTypeId">
                    {{
                      overtimeTypeName(data[indextr].overtimeTypeId)
                        .overtimeTypeName
                    }}
                  </vs-td>
                  <vs-td :data="data[indextr].overtimeHours">
                    {{ data[indextr].overtimeHours }}
                  </vs-td>
                  <vs-td :data="data[indextr].otRate">
                    {{ data[indextr].otRate }}
                  </vs-td>
                  <!-- removed NSD Rate column as per payroll's request. Can be added back later if needed.
                  <vs-td :data="data[indextr].nsdRate">
                    {{ data[indextr].nsdRate }}
                  </vs-td> -->
                  <vs-td :data="data[indextr].hourlyRate">
                    {{ data[indextr].hourlyRate }}
                  </vs-td>
                  <vs-td>
                    <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
                      <feather-icon
                        icon="Edit3Icon"
                        svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                        @click="editRecord(data[indextr].id)"
                      />
                      <feather-icon
                        icon="Trash2Icon"
                        svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                        @click="confirmDeleteRecord(data[indextr].id)"
                      />
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </template>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-button
          type="gradient"
          color="primary"
          @click="promptAddNewovertime()"
          icon-pack="feather"
          icon="icon-plus"
          >Add</vs-button
        >
      </div>
    </div>

    <!-- ADD overtime -->
    <vs-prompt
      class="email-compose"
      title="Edit overtime"
      accept-text="Submit"
      @accept="onAddRecord"
      :is-valid="validForm"
      :active.sync="activePromptAddRecord"
    >
      <vx-card title="You may update the following information">
        <div class="vx-row mb-3">
          <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
            <span class="text-sm">Payroll Type</span>
            <span style="color: red">*</span>
            <v-select
              name="payroll type"
              v-validate="'required'"
              class="w-full"
              v-model="createPayroll"
              label="createPayrollId"
              :options="getAllActiveCreatePayrollId"
              placeholder="Please Select"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('payroll type')"
              >{{ errors.first("payroll type") }}</span
            >
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
            <span class="text-sm">Overtime Type</span>
            <span style="color: red">*</span>
            <v-select
              name="overtime type"
              v-validate="'required'"
              class="w-full"
              v-model="overtimeType"
              label="overtimeTypeName"
              :options="getAllOvertimeTypeLookup"
              placeholder="Please Select"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('overtime type')"
              >{{ errors.first("overtime type") }}</span
            >
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
            <span class="text-sm">OT Hours</span
            ><span style="color: red">*</span>
            <vs-input
              name="ot hours"
              v-validate="'max_value:1000'"
              class="w-full"
              v-model="overtimeHours"
            />
            <span class="text-danger text-sm" v-show="errors.has('ot hours')">{{
              errors.first("ot hours")
            }}</span>
          </div>
        </div>
      </vx-card>
    </vs-prompt>
    <!-- END ADD overtime -->
    <!-- EDIT overtime -->
    <vs-prompt
      class="email-compose"
      title="Edit overtime"
      accept-text="Submit"
      @accept="onUpdateRecord"
      :is-valid="validForm"
      :active.sync="activePromptEditRecord"
    >
      <vx-card title="You may update the following information">
        <div class="vx-row mb-3">
          <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
            <span class="text-sm">Overtime Type</span>
            <span style="color: red">*</span>
            <v-select
              name="overtime type"
              v-validate="'required'"
              class="w-full"
              v-model="overtimeType"
              label="overtimeTypeName"
              :options="getAllOvertimeTypeLookup"
              placeholder="Please Select"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('overtime type')"
              >{{ errors.first("overtime type") }}</span
            >
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
            <span class="text-sm">OT Hours</span
            ><span style="color: red">*</span>
            <vs-input
              name="ot hours"
              v-validate="'max_value:1000'"
              class="w-full"
              v-model="overtimeHours"
            />
            <span class="text-danger text-sm" v-show="errors.has('ot hours')">{{
              errors.first("ot hours")
            }}</span>
          </div>
        </div>
      </vx-card>
    </vs-prompt>
    <!-- END EDIT overtime -->
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import { en, he } from "vuejs-datepicker/src/locale";

import moment from "moment";
import vSelect from "vue-select";

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
export default {
  props: {
    paymentMode: {
      type: Number,
      required: true,
    },
    userId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selected: [],

      overtimeId: 0,
      overtimeType: [],
      overtimeHours: 0,
      nsdRate: 0,
      otRate: 0,
      hourlyRate: 0,
      isManuallyAdded: false,
      addedManuallyOn: null,
      addedManuallyBy: "",
      uploadedOn: null,
      uploadedBy: "",
      extractedOn: null,
      extractedBy: "",
      createPayrollId: 0,

      createPayroll: null,

      activePromptAddRecord: false,
      activePromptEditRecord: false,

      configdateTimePicker: {
        allowInput: true,
      },

      sortKey: "",
      sortOrder: 1, //1 ascending, -1 Descending
    };
  },
  created() {
    this.$vs.loading();
    this.$store.dispatch("lookup/getAllOvertimeType").catch((err) => {
      console.log(err);
    });
    this.$store.dispatch("lookup/getAllPeriodLookup").catch((err) => {
      console.log(err);
    });
    this.$store
      .dispatch("lookup/getAllCreatePayrollTypeLookup")
      .catch((err) => {
        console.log(err);
      });
    this.$store.dispatch("payroll/getAllCreatePayroll").catch((err) => {
      console.log(err);
    });
    this.$store
      .dispatch("payroll/getAllOvertime")
      .then(() => {
        this.$vs.loading.close();
      })
      .catch((err) => {
        console.log(err);
      });

    //
  },
  components: {
    "v-select": vSelect,
    Datepicker,
    flatPickr,
  },
  computed: {
    getAllOvertime() {
      return this.$store.getters["payroll/getOvertimeByUserId"](this.userId);
    },
    getAllOvertimeTypeLookup() {
      return this.$store.state.lookup.overtimeTypes;
    },
    getAllPeriodByPaymentMode() {
      return this.$store.getters["lookup/periodLookupByPaymentMode"](
        this.paymentMode
      );
    },
    overtimeTypeName() {
      return (id) => this.$store.getters["lookup/overtimeType"](id);
    },
    getAllActiveCreatePayrollId() {
      return this.$store.getters["payroll/getAllActiveCreatePayrollId"]();
    },
    periodName() {
      return (id) => this.$store.getters["lookup/periodLookup"](id);
    },
    getCreatePayrollTypeName() {
      return (id) => this.$store.getters["lookup/createPayrollTypeIdById"](id);
    },
    validForm() {},
    getCurrentDate() {
      return moment(new Date()).format("YYYY-MM-DD");
    },

    sortedOvertimeData() {
      console.log("Computed: sortedOvertimeData called"); // Log when the computed property is called

      if (this.sortKey) {
        const sortedData = this.getAllOvertime.slice().sort((a, b) => {
          let aValue = a[this.sortKey];
          let bValue = b[this.sortKey];

          // Handle undefined or null values
          if (aValue == null) return this.sortOrder;
          if (bValue == null) return -this.sortOrder;

          // Compare numbers or strings
          if (typeof aValue === "number" && typeof bValue === "number") {
            return this.sortOrder * (aValue - bValue);
          }
          return this.sortOrder * aValue.localeCompare(bValue);
        });

        // Log the sorted data for debugging
        console.log("Sorted Data:", sortedData);
        return sortedData;
      } else {
        return this.getAllOvertime;
      }
    },
  },
  methods: {
    promptAddNewovertime() {
      this.getEmployeeSalary();
      this.activePromptAddRecord = true;
    },
    getEmployeeSalary() {
      this.$store.dispatch("hrms/getAllSalary", this.userId).then((res) => {
        console.log(res.data.data[0].hourlyRate);
        this.hourlyRate = res.data.data[0].hourlyRate;
      });
    },
    editRecord(id) {
      const e = this.$store.getters["payroll/getOvertimeById"](id);

      this.overtimeId = e.id;
      (this.createPayrollId = e.createPayrollId),
        (this.overtimeType = this.overtimeTypeName(e.overtimeTypeId)),
        (this.overtimeHours = e.overtimeHours),
        (this.otRate = e.otRate),
        (this.nsdRate = e.nsdRate),
        (this.hourlyRate = e.hourlyRate),
        (this.isManuallyAdded = e.isManuallyAdded),
        (this.addedManuallyOn = e.addedManuallyOn),
        (this.addedManuallyBy = e.addedManuallyBy),
        (this.uploadedOn = e.uploadedOn),
        (this.uploadedBy = e.uploadedBy),
        (this.extractedOn = e.extractedOn),
        (this.extractedBy = e.extractedBy),
        (this.userId = e.userId),
        (this.activePromptEditRecord = true);
    },
    confirmDeleteRecord(id) {
      this.$vs.loading();
      //console.log(id)
      this.$store
        .dispatch("payroll/DeleteEmployeeOvertime", id)
        .then((res) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Success",
            text: "Overtime Deleted",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success",
          });
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.status == 400) {
            this.$vs.notify({
              title: "Information",
              text: "Cannot be deleted. The item is in used",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
            });
          } else {
            this.$vs.notify({
              title: "Error",
              text: "test",
              iconPack: "feather",
              icon: "icon-x-octagon",
              color: "danger",
            });
          }
        });
    },
    onAddRecord() {
      this.$vs.loading();

      const e = {
        createPayrollId: this.createPayroll.createPayrollId,
        overtimeTypeId: this.overtimeType.overtimeTypeId,
        overtimeHours: this.overtimeHours,
        otRate: this.overtimeTypeName(this.overtimeType.overtimeTypeId).otRate,
        nsdRate: this.overtimeTypeName(this.overtimeType.overtimeTypeId)
          .nsdRate,
        hourlyRate: this.hourlyRate,
        isManuallyAdded: true,
        addedManuallyOn: this.getCurrentDate,
        addedManuallyBy: this.$store.state.AppActiveUser.uid,
        uploadedOn: this.uploadedOn,
        uploadedBy: this.uploadedBy,
        extractedOn: this.extractedOn,
        extractedBy: this.extractedBy,
        userId: this.userId,
        currentUserId: this.$store.state.AppActiveUser.uid,
      };
      console.log(e);
      this.$store.dispatch("payroll/AddEmployeeOvertime", e).then((res) => {
        this.$vs.loading.close();
      });
    },
    onUpdateRecord() {
      const e = {
        createPayrollId: this.createPayrollId,
        overtimeTypeId: this.overtimeType.overtimeTypeId,
        overtimeHours: this.overtimeHours,
        otRate: this.otRate,
        nsdRate: this.nsdRate,
        hourlyRate: this.hourlyRate,
        isManuallyAdded: this.isManuallyAdded,
        addedManuallyOn: this.addedManuallyOn,
        addedManuallyBy: this.addedManuallyBy,
        uploadedOn: this.uploadedOn,
        uploadedBy: this.uploadedBy,
        extractedOn: this.extractedOn,
        extractedBy: this.extractedBy,
        userId: this.userId,
        id: this.overtimeId,
        currentUserId: this.$store.state.AppActiveUser.uid,
      };
      this.$store
        .dispatch("payroll/UpdateEmployeeOvertime", e)
        .then((res) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Success",
            text: "Overtime Updated",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "primary",
          });
        })
        .catch((error) => {
          this.$vs.loading.close();

          this.$vs.notify({
            title: "Error",
            text: error.message,
            iconPack: "feather",
            icon: "icon-x-octagon",
            color: "danger",
          });
        });
    },
    sort(key) {
      console.log("Method: sort called with key:", key); // Log when the sort method is called

      if (this.sortKey === key) {
        this.sortOrder *= -1;
      } else {
        this.sortKey = key;
        this.sortOrder = 1;
      }

      // Log the current sort key and order for debugging
      console.log("Sort Key:", this.sortKey);
      console.log("Sort Order:", this.sortOrder);
    },
  },
};
</script>
